module.exports = __webpack_public_path__ + "static/img/gou.c648ec59.png";